module.exports = __webpack_public_path__ + "903b24b509988ae3e0918b050af4f9aa.otf";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/Poppins-Medium.otf
// module id = 877
// module chunks = 0